<div class="bg-white p-3" [hidden]="isLoading">
    <div class="flex-align-center flex justify-between">
        <div class="py-4">
            <p class="empty-status-search-result__description" *ngIf="!data?.length">
                {{ 'EMPTY_STATUS_SEARCH_RESULT_NOT_FOUND' | translate }}
            </p>
            <rwidget-route-name
                *ngIf="!isLoading && data?.length > 0"
                [routeNumberLabel]="selectedOption?.route.shortName"
                [routeNumberColor]="selectedOption?.route?.icon?.color || selectedOption?.route?.color"
                [routeNumberShape]="selectedOption?.route?.icon?.shape || ShapeType.ROUNDED"
                [name]="selectedOption?.route?.longName || selectedOption?.route?.agency?.name"
                [agency]="selectedOption?.route?.agency"></rwidget-route-name>
        </div>
        <rwidget-route-name
            *ngIf="isLoading"
            [routeNumberLabel]="selectedOption?.route.shortName"
            [routeNumberColor]="selectedOption?.route?.icon?.color || selectedOption?.route?.color"
            [routeNumberShape]="selectedOption?.route?.icon?.shape || ShapeType.ROUNDED"
            [name]="selectedOption?.route?.longName"></rwidget-route-name>
        <ion-button
            class="m-0 !h-auto"
            [attr.aria-label]="'LOCAL_BTN_BACK' | translate"
            (click)="navigateBack()"
            slot="end"
            fill="clear">
            <ion-icon
                class="h-8 w-8 dark:filter-yellow"
                title="{{ 'LOCAL_BTN_BACK' | translate }}"
                attr.aria-label="{{ 'LOCAL_BTN_BACK' | translate }}"
                src="{{ assetsPath$ | async }}/img/explore/cross.svg"></ion-icon>
        </ion-button>
    </div>

    <div class="flex-justify-between flex overflow-x-auto" *ngIf="data.length <= 2">
        <div class="w-[50%] min-w-[50%] max-w-[50%]" *ngFor="let option of data; let i = index">
            <ridango-ui-tab-button
                [ariaLabel]="patternLabels[i]"
                [isSelected]="option === selectedOption"
                (click)="handlePatternSelect(option)"
                >{{ patternLabels[i] }}</ridango-ui-tab-button
            >
        </div>
    </div>

    <div *ngIf="data.length > 2">
        <ion-item
            class="stops-dropdown rounded-lg border border-solid border-gray-300 py-1 shadow"
            (click)="openModal()"
            lines="none">
            {{ patternLabels[data.indexOf(selectedOption)] }}
            <ion-icon
                class="text-old_silver opacity-50 dark:text-contrast-yellow"
                slot="end"
                name="caret-down"></ion-icon>
        </ion-item>
    </div>

    <ng-container *ngFor="let stop of selectedOption?.stops ?? []">
        <div class="border-ironside_grey-100 mb-3 mt-3 border-t border-solid dark:border-contrast-yellow"></div>
        <div class="grid cursor-pointer grid-cols-[2rem_1fr_auto]" (click)="handleStopSelect(stop)">
            <div class="flex-justify-center flex-align-center flex h-full w-full">
                <ion-icon
                    class="hu-light:text-grey-zambezy h-[1.6rem] w-[1.6rem] rounded text-white dark:text-contrast-yellow"
                    [src]="(assetsPath$ | async) + '/img/explore/bus.svg'"
                    aria-hidden="true"></ion-icon>
            </div>
            <div class="flex-align-center ml-5 mr-5 flex">{{ stop.name }}</div>
        </div>
    </ng-container>
</div>

<ridango-ui-basic-loading-spinner *ngIf="isLoading"></ridango-ui-basic-loading-spinner>
